var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('a',{attrs:{"href":_vm.preweb + _vm.number}},[_vm._v("Block")])])}
var staticRenderFns = []

export { render, staticRenderFns }